import { Container, useMediaQuery, useTheme } from '@mui/material';
import { FunctionComponent } from 'react';
import { CustomerSelector } from '../../../customers/components/CustomerSelector/CustomerSelector';
import { LanguageSelector } from '../LanguageSelector/LanguageSelector';
import { LogoutButton } from '../LogoutButton/LogoutButton';

export const MobileHeaderMenu: FunctionComponent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'));
  return isMobile
    ? <Container
      maxWidth={false}
      sx={{
        background: 'transparent',
        display: 'fixed',
        width: '100%',
        height: 64,
        boxShadow: 2,
        p: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 1,
      }}
    >
      <CustomerSelector />
      <LanguageSelector />
      <LogoutButton />
    </Container>
    : null;
};
